import React from 'react';
import '../../styles/productDetail.css';

/**
 * Reusable Specifications/Attributes grid.
 * Dynamically checks for defined product properties and displays only those
 * that exist (no empty value rendering).
 *
 * @param {Object} props
 * @param {Object} props.product - The product database document
 */
const ProductSpecs = ({ product }) => {
  if (!product) return null;

  const categoryName = product.category?.name || 'General';

  // Define spec mapping list (with custom value formatters)
  const specDefinitions = [
    { label: 'Category', value: categoryName },
    { label: 'Section', value: product.section },
    { label: 'Min. Order Qty', value: product.moq ? `${product.moq} ${product.moqType === 'set' ? 'Sets' : 'Pcs'}` : null },
    { label: 'MRP', value: product.mrp ? `₹${Number(product.mrp).toLocaleString('en-IN')}` : null },
    { label: 'Units Per Set', value: product.unitsPerSet ? `${product.unitsPerSet} pcs` : null },
    { label: 'Brand', value: product.brand },
    { label: 'Material', value: product.material },
    { label: 'Country Of Origin', value: product.countryOfOrigin },
    { label: 'Sizes', value: product.sizes && product.sizes.length > 0 ? product.sizes.join(', ') : null }
  ];

  // Filter out any undefined, null, or empty values
  const activeSpecs = specDefinitions.filter((spec) => {
    const val = spec.value;
    return val !== undefined && val !== null && val !== '' && (!Array.isArray(val) || val.length > 0);
  });

  if (activeSpecs.length === 0) {
    return null; // Don't show specs header if no specs are defined
  }

  return (
    <div className="product-attributes-panel">
      <h4 className="product-attributes-title">Product Specifications</h4>
      <div className="attributes-specs-grid">
        {activeSpecs.map((spec, idx) => (
          <div className="spec-item-box" key={`spec-${idx}`}>
            <span className="spec-label">{spec.label}</span>
            <span className="spec-value">{spec.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProductSpecs;
